import Page from './AnalysisBlock.js';
import { connect } from 'react-redux';
import { post } from '../../../../common/utils';

const getHistoryDetails = (time_begin, time_end, kpi_factor_id) => {
    return (dispatch, getState) => {
        return post(process.env.REACT_APP_SERVER_PATH + 'api/kpi/get_history_data_with_details', {
            time_begin,
            time_end,
            kpi_factor_id,
        }).then(retData => {
            // console.log(retData);
            if (retData.data && retData.data.errcode === 0) {
                // dispatch(setValues({ kpiList: retData.data.results }));
                return {
                    isSuccess: true,
                    result: retData.data,
                };
            };
            return {
                isSuccess: false,
            };
        });
    };
};

const mapStateToProps = state => {
    const { referenceFactors } = state;
    const { systems, timeRange } = referenceFactors;
    return {
        systems,
        timeRange,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getHistoryDetails: (time_begin, time_end, kpi_factor_id) => dispatch(getHistoryDetails(time_begin, time_end, kpi_factor_id)),
    };
};

const WrapperedPage = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Page);

export default WrapperedPage;